<template>
  <section class="sec sec-alt">
    <div class="sec-inner">
      <div class="sec-head">
        <div class="sec-eyebrow">产品</div>
        <h2 class="sec-title">自研产品</h2>
        <p class="sec-sub">工作之余独立开发的产品，从设计、开发到运营都由自己完成。</p>
      </div>

      <v-row>
        <v-col
          v-for="p in products"
          :key="p.name"
          cols="12"
          sm="6"
          lg="6"
          class="product-col"
        >
          <ProductCard :product="p" />
        </v-col>
      </v-row>

      <div class="sec-more">
        <router-link to="/works" class="more-link">
          全部产品与项目 &rarr;
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import ProductCard from "@/components/ProductCard";
import { products } from "@/assets/js/profile";

export default {
  name: "ProductSection",
  components: { ProductCard },
  data() {
    return {
      // 首页只放前 6 个，其余进 /works
      products: products.slice(0, 6)
    };
  }
};
</script>

<style scoped>
.sec-head {
  margin-bottom: 44px;
}
.product-col {
  display: flex;
}
.sec-more {
  margin-top: 34px;
}
.more-link {
  font-size: 15px;
  color: var(--accent);
  font-weight: 500;
}
.more-link:hover {
  color: var(--accent-deep);
}
</style>
